import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'ngx-session-attachments-popover',
	templateUrl: './session-attachments-popover.component.html',
	styleUrls: ['./session-attachments-popover.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class NgxSessionAttachmentsPopoverComponent {
	@Input() public session: any;
	@Input() public user: any;
	@Input() public group: any;
	@Input() public readonlyMode = false;
	@Input() public activityName: string;
	@Input() public attachmentsCount = 0;
}
